import React from 'react';
import PropTypes from 'prop-types';
import RenderComponentProto from '../../render-component-proto';

import DatepickerComponent from 'core/gd-components/datetime/datepicker/datepicker.jsx';
import DateTimeUtils from 'core/gd/utils/datetime-utils';

import Classes from 'classnames';
import Moment from 'moment';

export default class DateComponentProto extends RenderComponentProto {

    static propTypes = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        showDeleteButton: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        canEdit: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this._bind('onChange');
    }

    onChange(newValue) {
        const newFormattedDate = newValue ? Moment(newValue).format('YYYY-MM-DD') : null;

        this.setState({value: newFormattedDate}, () => {
            if (this.props.onChange) this.props.onChange(newFormattedDate);
        });
    }

    render() {
        const classes = Classes('gd-field-date', this.props.renderMode, {
            'disabled': this.props.canEdit === false,
        });
        const selectedValue = this.state.value ? DateTimeUtils.dateToMoment(this.state.value) : null;

        let skin = null;
        let popoverAttachment = null;
        let popoverTargetAttachment = null;
        let popoverTargetOffset = '0 0';
        let tetherConstraints = null;

        if (['view','edit','form-new'].includes(this.props.renderMode)) {
            skin = 'inline';
            popoverAttachment = 'middle right';
            popoverTargetAttachment = 'middle left';
            tetherConstraints = [
                { to: 'window',        attachment: 'together' },
                // { to: 'scrollParent',  attachment: 'together' }
            ];
        }

        if (this.props.renderMode === 'list') {
            skin = 'list';
            popoverAttachment = 'top center';
            popoverTargetAttachment = 'bottom center';
            popoverTargetOffset = "10 0";
            tetherConstraints = [
                { to: 'window',        attachment: 'together' }
            ];
        }

        return (
            <div className={classes}>
                <DatepickerComponent value={selectedValue}
                                     markPastdue={false}
                                     valueFormat="MMM DD, YYYY"
                                     placeholderText="Select date"
                                     skin={skin}
                                     onSelect={this.onChange}
                                     popoverAttachment={popoverAttachment}
                                     popoverTargetAttachment={popoverTargetAttachment}
                                     popoverTargetOffset={popoverTargetOffset}
                                     tetherConstraints={tetherConstraints}
                                     attachmentType="vertical"
                                     btnDelete={this.props.showDeleteButton}
                                     disabled={this.props.canEdit === false} />
            </div>
        );
    }
}